import { Component, OnInit } from '@angular/core';
import { Shared } from '../shared.service';


@Component({
  selector: 'app-mobile-menu-button',
  templateUrl: './mobile-menu-button.component.html',
  styleUrls: ['./mobile-menu-button.component.scss']
})
export class MobileMenuButtonComponent implements OnInit {

  constructor(public shared: Shared) { }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// ./src/app/mobile-menu-button/mobile-menu-button.component.ts